class CartNotification extends HTMLElement {
  constructor() {
    super();

    // 通知コンテナ要素を取得
    this.notification = document.getElementById('cart-notification');
    // sticky-header が存在すれば取得
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    // Escapeキーで閉じる
    if (this.notification) {
      this.notification.addEventListener('keyup', (evt) => {
        if (evt.code === 'Escape') this.close();
      });
    }

    // 閉じるボタンすべてにクリックイベント
    this.querySelectorAll('button[type="button"]').forEach((closeButton) => {
      closeButton.addEventListener('click', this.close.bind(this));
    });
  }

  open() {
    if (!this.notification) return;
    this.notification.classList.add('animate', 'active');

    // アニメーション終了後にフォーカスを当てる
    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    if (!this.notification) return;
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;

    // 各セクションを更新
    this.getSectionsToRender().forEach((section) => {
      const container = document.getElementById(section.id);
      if (container) {
        const html = parsedState.sections[section.id];
        const newInner = this.getSectionInnerHTML(html, section.selector);
        container.innerHTML = newInner;
      }
    });

    // sticky-header があれば再表示
    if (this.header && typeof this.header.reveal === 'function') {
      this.header.reveal();
    }

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    // DOMParser でパースし、selector にマッチした要素を抽出
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const el = doc.querySelector(selector);
    return el ? el.innerHTML : '';  // null チェックを追加
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (
      this.notification &&
      target !== this.notification &&
      !target.closest('cart-notification')
    ) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

// カスタム要素として定義
customElements.define('cart-notification', CartNotification);
